import { reset } from 'redux-form';
import {
    CLEAR_AI_RESPONSE,
    OPEN_AI_RESPONSE_ERROR,
    OPEN_AI_RESPONSE_START,
    OPEN_AI_RESPONSE_SUCCESS
} from "../../../constants";
import getResponseWithOpenAI from "../../../lib/AIFeatures/OpenAI/getResponseWithOpenAI";

export function clearAIResponse() {
    return (dispatch) => {
        dispatch(reset('ReservationMessage'));
        dispatch({ type: CLEAR_AI_RESPONSE });
    };
}

const manageOpenAIResponse = ({ name, prompt }) => {
    return (dispatch) => {
        dispatch({ type: OPEN_AI_RESPONSE_START });

        return new Promise((resolve, reject) => {
            try {
                getResponseWithOpenAI({ prompt })
                    .then(({ status, content }) => {
                        if (status === 200) {
                            dispatch({
                                type: OPEN_AI_RESPONSE_SUCCESS,
                                payload: { name, content: JSON.parse(content) },
                            });
                            resolve();
                        } else {
                            dispatch({ type: OPEN_AI_RESPONSE_ERROR, payload: { name, content } });
                            reject();
                        }
                    })
                    .catch(err => {
                        dispatch({ type: OPEN_AI_RESPONSE_ERROR, payload: err?.message });
                        reject(err);
                    });
            } catch (error) {
                dispatch({ type: OPEN_AI_RESPONSE_ERROR, payload: error?.message });
                reject(error);
            }
        });
    };
}

export default manageOpenAIResponse;
